import type { ReactNode } from "react";

/**
 * Hero variants, named for the classes the approved design uses, so a page's
 * stylesheet and its scene cannot drift apart:
 *   `split`   an artifact beside the headline (services)
 *   `process` a centred column over a stage nav (how we work)
 *   `usecase` a wide headline against a short aside (pain points)
 *   `heading` a two-column opening (faq)
 */
export type SceneVariant = "heading" | "process" | "split" | "usecase";

interface PageSceneProps {
  children: ReactNode;
  variant: SceneVariant;
}

/**
 * The opening band. It runs wider than the page measure and carries its own
 * inner wrap, so the surface extends past the content without the content
 * moving with it.
 */
export function PageScene({ children, variant }: Readonly<PageSceneProps>) {
  return (
    <section className="scene">
      <div className={`wrap ${variant}-hero`}>{children}</div>
    </section>
  );
}
